import { useRouter } from 'next/router'
import { parseCookies, setCookie } from 'nookies'
import { useCallback, useEffect } from 'react'

export const useAffiliateTracking = () => {
  const router = useRouter()

  useEffect(() => {
    const queryValue = router.query.a
    const affiliateTagCode = typeof queryValue === 'string' ? queryValue : undefined
    if (affiliateTagCode) {
      const thirtyDays = 30 * 24 * 60 * 60
      setCookie(null, 'affiliate_tag', affiliateTagCode, {
        maxAge: thirtyDays,
        path: '/',
        secure: typeof window !== 'undefined' && window.location.protocol === 'https:',
        sameSite: 'lax',
      })
    }
  }, [router.query.a])

  const getAffiliateTagCode = useCallback((): string | null => {
    const cookies = parseCookies()
    return cookies.affiliate_tag || null
  }, [])

  return { getAffiliateTagCode }
}
